import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { CreateProductCompositionsParams, ProductCompositionsData } from "../../types/product-compositions-modal.types";
import { defaultProductCompositionsData } from "../../configs/default-product-compositions-data";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import { ProductCompositionsModalService } from "../../services/product-compositions-modal.service";
import { RecordUpdateRequestParams } from "../../../../../../../../core/types/records-table.types";
import { productCompositionsResourceType } from "../../configs/product-compositions-modal-config";
import { productCompositionFormFields } from "../../configs/product-composition-form-fields";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-product-compositions-form',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatButton
  ],
  templateUrl: './product-compositions-form.component.html',
  styleUrls: [
    '../../product-compositions-modal.component.scss',
    './product-compositions-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCompositionsFormComponent {
  parentId = input<number>(0);
  productCompositionData = input<ProductCompositionsData>(defaultProductCompositionsData);
  productCompositionFormGroup = input<FormGroup>(new FormGroup({}));
  noFirstData = input<boolean>(false);
  isEditModeActive = input<boolean>(false);
  updateProductCompositionData = output<ProductCompositionsData>();
  deleteProductComposition  = output<void>();

  private productCompositionsModalService: ProductCompositionsModalService = inject(ProductCompositionsModalService);

  public readonly productCompositionFormFields = productCompositionFormFields;

  public getFieldClass(): string {
    if (!this.productCompositionData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.productCompositionData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: productCompositionsResourceType.path,
      recordId: this.productCompositionData().id,
      fieldName: key,
      value: this.productCompositionFormGroup().get(key)?.value
    };

    const data = await this.productCompositionsModalService.updatedRecordField<ProductCompositionsData>(params)
      .catch(() => this.productCompositionData());
    this.updateProductCompositionData.emit(data);
  }

  public handelDelete(): void {
    this.deleteProductComposition.emit();
  }

  public async handelCreate(): Promise<void> {
    const createProductCompositionsParams: CreateProductCompositionsParams = {
      technicalParametersId: this.parentId(),
      ...this.productCompositionFormGroup().value
    };

    const data = await this.productCompositionsModalService.createProductComposition(createProductCompositionsParams)
      .catch(() => defaultProductCompositionsData);
    this.updateProductCompositionData.emit(data);
  }
}
